import React from "react"
import { siteUrl } from "../../../utils/siteUrl"
import IconCard from "../../../assets/images/icon_card_sostenibilidad.png"
import "./float-sustainability-card-mb.scss"

const FloatSustainabilityCardMB = () => {

    const homeLink = siteUrl

    return (
        <div className="f-sustainability-card-mb">
            <a href={homeLink + '/magazin/sostenibilidad'}>
                <div className="f-sustainability-card-mb__container">
                    <h2 className="f-sustainability-card-mb__container-title">
                        Nosotras trabajando por un mundo más sostenible
                    </h2>
                    <img className="f-sustainability-card-mb__container-image" src={IconCard} alt="icon-card" />
                    <p className="f-sustainability-card-mb__container-description">
                        Conoce todas las iniciativas sociales y ambientales de Nosotras y Grupo Familia a las que apoyas por preferir nuestros productos.
                    </p>
                </div>
            </a>
        </div>
    )
}

export default FloatSustainabilityCardMB